import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import './PdfPreviewModal.css';

interface PdfPreviewModalProps {
  title: string;
  url: string;
  onClose: () => void;
}

export default function PdfPreviewModal({ title, url, onClose }: PdfPreviewModalProps) {
  useEffect(() => {
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', closeOnEscape);
    return () => window.removeEventListener('keydown', closeOnEscape);
  }, [onClose]);

  return (
    <div className="tutorial-pdf-modal" role="presentation" onClick={onClose}>
      <div className="tutorial-pdf-dialog" role="dialog" aria-modal="true" aria-labelledby="tutorial-pdf-title" onClick={(event) => event.stopPropagation()}>
        <div className="tutorial-pdf-dialog-header">
          <div><strong id="tutorial-pdf-title">{title}</strong><span>Source PDF</span></div>
          <button className="tutorial-pdf-close" onClick={onClose} aria-label="Close PDF preview" title="Close PDF preview"><X size={18} /></button>
        </div>
        <iframe src={url} title={`${title} PDF`} />
        <a className="tutorial-pdf-download" href={url} target="_blank" rel="noreferrer">Open PDF in a new tab</a>
      </div>
    </div>
  );
}
